import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";

function CustomDateRangePicker({ value, onChange }) {
  const [dateRange, setDateRange] = useState(value || [null, null]);
  const [startDate, endDate] = dateRange;

  // Keep internal state in sync with external value
  useEffect(() => {
    if (
      (value?.[0] !== dateRange[0]) ||
      (value?.[1] !== dateRange[1])
    ) {
      setDateRange(value || [null, null]);
    }
  }, [value]);

  const handleChange = (update) => {
    setDateRange(update);
    onChange(update);
  };
  
  return (
    <DatePicker
      className="border-0 bg-transparent p-2"
      placeholderText="Filter by date range"
      startDate={startDate}
      endDate={endDate}
      onChange={handleChange}
      selectsRange
      withPortal
    />
  );
}

export default CustomDateRangePicker;
